module.exports = __webpack_public_path__ + "img/logo.1882f7a3.png";